//write global plain javascript functions here...

var loadingGroupCount = {};
function loading(status, opacity, selector, groupName) {
    /* WEB-2840 AMS: EOIs page - Missing Loading Indicator
    * Need to allow loading for a group of calls
    * Only hide loading when all calls in a group are finished loading */
    if(groupName){
        if(!status){
            loadingGroupCount[groupName] = loadingGroupCount[groupName] ? (loadingGroupCount[groupName] - 1) : null;
            if(loadingGroupCount[groupName]) return false; // If loading group count > 0 then need to keep showing loading
        }else{
            loadingGroupCount[groupName] = loadingGroupCount[groupName] ? (loadingGroupCount[groupName] + 1) : 1;
        }
    }

    var id = 'div_ss_loading_spinner' + (selector ? '_sub' : '');

    var body = jQuery(selector ? selector : 'body');
    var modal = body.find('#'+id);

    if (modal && modal.length > 0) {
        modal = jQuery(modal[0]);
    } else {
        modal = jQuery('<div/>');
        modal.attr('id', id);
        modal.attr('tabindex', 0);
        modal.css({
            position: selector ? 'absolute' : 'fixed',
            left: '0px',
            top:'0px',
            width: '100%',
            height: '100%',
            overflow: 'auto',
            cursor: 'progress',
            'z-index': '99999',
            'background-image': 'url(/images/ss_loader.gif)',
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            'background-size': '100px 100px',
            'display': 'none'
        });
        body.append(modal);
    }

    if (status) {
        if (!selector) {
            body.css({overflow: 'hidden'});
        }

        modal.css({
            display: 'block',
            'background-color': 'rgba(0, 0, 0, '+(opacity == null || opacity == undefined ? 0.4 : opacity)+')'
        });

        if (!selector) {
            modal.focus();
        }
    } else {
        if (!selector) {
            body.css({overflow: 'auto'});
        }
        modal.css({display: 'none'});
    }

    modal.keydown(function(e) {
        e.preventDefault();
    });

}

function getFromArray(array, k, v) {
    if (!array || array.length == 0 || !k || !v) return;

    var object = null;
    jQuery.each(array, function(i, o) {
        if (o[k] == v) {
            object = o;
            return false;
        }
    });

    return object;
}



/** WakeLock Code Initialization **/
var WAKE_LOCK = null; // create a reference for the wake lock

function isWakeLockSupported() { // To check if browser supports wakeLock
    try{
        return 'wakeLock' in navigator;
    } catch(e){
        console.error(e);
        return false;
    }
}

// If tab becomes active and wakeLock was engaged, reEngage wakeLock
const handleVisibilityChange = () => {
    try {
        if (WAKE_LOCK !== null && document.visibilityState === 'visible') {
            requestWakeLock();
        }
    } catch (e) {
        console.error(e);
    }
}

// create an async function to request a wake lock
const requestWakeLock = async () => {
    if (!isWakeLockSupported()) { // check browser support for wakeLock
        console.warn("wakeLock not supported by browser");
        return;
    }

    try {
        WAKE_LOCK = await navigator.wakeLock.request('screen');
        console.log("wakeLock Acquired");

        // listen for our release event
        /*WAKE_LOCK.onrelease = function (ev) {
            console.log("wakeLock release event triggered", ev);
        }*/

        WAKE_LOCK.addEventListener('release', () => {
            console.log("wakeLock Released");
        });

        // Init visibilitychange listener to re-trigger wakeLock if tab becomes active after changing
        document.addEventListener('visibilitychange', handleVisibilityChange);
    } catch (err) {
        // if wake lock request fails - usually system related, such as battery
        console.log(`${err.name}, ${err.message}`);
    }
} // requestWakeLock()

const releaseWakeLock = async () => {
    if (!isWakeLockSupported()) { // check browser support for wakeLock
        console.warn("wakeLock not supported by browser");
        return;
    }

    if (!WAKE_LOCK) { // check if wakeLock exists
        console.warn("wakeLock not engaged.");
        return;
    }

    try {
        WAKE_LOCK.release()
            .then(() => {
                WAKE_LOCK = null; // clear wakeLock
            })
    } catch (err) {
        // if wake lock request fails - usually system related, such as battery
        console.log(`${err.name}, ${err.message}`);
    }
}
